import React, { useMemo, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import useMdUpScreen from '../../hooks/useMdUpScreen';

import HomeView from './View';
import { componerConfiguracion } from '../../store/selectors';
import { useSelector } from 'react-redux';

function Home() {
  const navigate = useNavigate();
  const handleNavigate = (path) => {
    navigate(path);
  };
  const templateRef= useRef(null);

  const selectViewConfig = useMemo(componerConfiguracion, []);
  const viewParameters = useSelector(state => selectViewConfig(state, 'Home'));
  
  const mdUpScreen = useMdUpScreen();


  return (<HomeView viewParameters={viewParameters} mdUpScreen={mdUpScreen} handleNavigate={handleNavigate} templateRef={templateRef} />);
}



export default Home;
